export default (state, payload) => {
  state.form_connection.credentials = payload;
};
